import { render } from "./SelectPlatform.vue?vue&type=template&id=6694ac55&scoped=true"
import script from "./SelectPlatform.vue?vue&type=script&lang=js"
export * from "./SelectPlatform.vue?vue&type=script&lang=js"

import "./SelectPlatform.vue?vue&type=style&index=0&id=6694ac55&scoped=true&lang=css"

import exportComponent from "Q:\\grdn-auth\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6694ac55"]])

export default __exports__